module.exports = __webpack_public_path__ + "static/media/typeOne.bbc41cf6.png";